import * as Config from '../../config';
import { default as Locale } from '../../utils/Locale';
import * as UUID from '../../utils/Uuid';
import { AlertInfo, AlertType, AlertRecord, AlertCategories } from "../Types";
import { AlertLogic } from './AlertLogic';
import { ContentCategories } from "../../types";

export class NotFiltered extends AlertLogic {
    static type = AlertType.NoWaterFiltered;
    static category = AlertCategories.WATER_QUIALITY;
    static contentCategories = [ ContentCategories.WATER_QUALITY ];
    static title = Locale.gettext('Not Filtered');

    getInfo(alert:AlertRecord = this.alert, config:Config.AllConfig = this.allConfigs):AlertInfo {
        // Same for all alert types
        let { body, device, alertData, firstReported } = this.getCommons(alert, config);

        // Varying across alert types
        let cardIllustration = 'pool_cleaning';
        let detailIcon = 'filter';
            
        const alertInfo = AlertInfo.fromCardConfig({
            cardTitle: this.locale.gettext('Filtering Needed'),
            cardDescription: this.locale.gettext('%1$s was not filtered recently', body.Name || device.Name),
            cardIllustration: cardIllustration,
            detailIcon: detailIcon,
            detailDescription: this.locale.gettext('In order to maintain the best water quality and conditions, you should ensure that the %1$s is filtered periodically.', body.Name || device.Name),
            detailDescription2: this.locale.gettext('Waiting too long in between can cause unfavorable conditions that could prevent you from using it!', body.Name || device.Name),
            actionButtonTitle: false,
            resolveSummary: this.locale.gettext('%1$s filtering started', body.Name),
        });        
        alertInfo.contentCategories = NotFiltered.contentCategories;
        return alertInfo;
    } 

    static mock(type:AlertType, config:Config.AllConfig):AlertRecord {
        let device = config.Config.BodiesOfWater[0];
        
        return device ? new AlertRecord({
            id: Math.floor(Math.random() * 100000),
            uuid: UUID.modifySection(4, UUID.modifySection(3, device.UUID, "MOCK"), "ALRT" + type),
            siteId: Math.floor(Math.random() * 100000),
            deviceId: 1,
            entityUuid: device?.UUID,
            bodyUuid: config.Config.BodiesOfWater[0]?.UUID,
            type: type,
            data: {
                
            }
        }) : null;
    }
}